// table-basket

function deleteProduct(event) {
	var td = $(event).parent();
	var tr = td.parent();
	tr.toggleClass('delete');
}

$('[data-rol="delete-basket-product"]').on('click', function(e) {
	deleteProduct($(this));
});

$('.basket-table__button-cancel').on('click', function(e) {
	e.preventDefault();
	var wrapper = $(this).parent();
	deleteProduct(wrapper);
});


$(window).on('resize load', function() {
	var basketTable = $('.js-table-basket');

	if ($(window).width() < 768) {
		var select = basketTable.find('.form__select');
		var quantity = basketTable.find('.form__quantity');
		select.each(function(index, value) {

			if($(this).siblings().hasClass('form__label')) {
				return;
			}

			$(this).before('<label class="form__label">Диоптрии</label>');
			$(this).parent().css('display', 'inline-block')
		})
		quantity.each(function(index, value){

			if($(this).siblings().hasClass('form__label')) {
				return;
			}

			$(this).before('<label class="form__label">Количество</label>');
			$(this).parent().css({
				'display': 'inline-block',
				'padding-left': '0'
			})
		})
	}
})
